import Component from '../abstracts/Component';

export default class MyAccountLayerComponent extends Component {
  get SELECTORS() {
    return {
      pwdRecoveryBtn: '[data-pwd-recovery-btn]',
      loginBtn: '[data-login-btn]',
      emailInput: '[data-modal-recovery-email]',
      recoveryForm: '[data-recovery-form] form',
      recoverySubmitBtn: '[data-submit-btn]',
      formEmailInput: 'fieldset input[type="email"]',
      formPswInput: 'fieldset input[type="password"]',
      myAccountLayerWrapper: '[data-myaccount-layer-wrapper]',
    };
  }

  get CSS() {
    return {
      recovery: '--recovery',
      success: '--success',
      visible: 'show',
    };
  }

  readDOM() {
    return {
      emailInput: this.$component.querySelector(this.SELECTORS.emailInput),
      pwdRecoveryBtn: this.$component.querySelector(this.SELECTORS.pwdRecoveryBtn),
      loginBtn: this.$component.querySelector(this.SELECTORS.loginBtn),
      recoveryForm: this.$component.querySelector(this.SELECTORS.recoveryForm),
      recoverySubmitBtn: this.$component.querySelector(this.SELECTORS.recoverySubmitBtn),
      formEmailInput: this.$component.querySelector(this.SELECTORS.formEmailInput),
      formPswInput: this.$component.querySelector(this.SELECTORS.formPswInput),
      myAccountLayerWrapper: document.querySelector(this.SELECTORS.myAccountLayerWrapper),
    }
  }

  sendRecovery() {
    const self = this;
    const url = this.dom.recoveryForm.getAttribute('action');
    const params = (new URLSearchParams(new FormData(this.dom.recoveryForm))).toString();

    return fetch(url, {
      method: 'POST',
      body: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(res => res.text())
      .then(rbody => {
        const rdoc = (new DOMParser()).parseFromString(rbody, 'text/html');
        const recovery = rdoc.querySelector('[data-recovery-email]');
        if(recovery) {
          const error = recovery.parentElement.parentElement.querySelector('[data-error]');
          if(error.innerText.trim()) throw new Error(error.innerText.trim());
        }

        return self.$component.querySelector('input[name=email]').value;
      });
  }

  bindEvents() {
    let self = this;
    // GO TO RECOVERY
    this.dom.pwdRecoveryBtn.addEventListener('click', () => {
      self.$component.classList.add(self.CSS.recovery);
      self.$component.classList.remove(self.CSS.success);
    });

    // FROM RECOVERY GO TO LOGIN
    this.dom.loginBtn.addEventListener('click', () => {
      self.$component.classList.remove(self.CSS.recovery);
      self.$component.classList.remove(self.CSS.success);
    });

    this.dom.recoveryForm.addEventListener('submit', evt => {
      evt.preventDefault();
      self.dom.recoverySubmitBtn.disabled = true;
      self.sendRecovery()
        .then((email) => {
          self.$component.querySelector('[data-recovery-message]').innerText = email;
          self.$component.classList.remove(self.CSS.recovery);
          self.$component.classList.add(self.CSS.success);
          setTimeout(function() {
            self.dom.myAccountLayerWrapper.classList.remove(self.CSS.visible);
          }, 3000);
        })
        .catch(err => {
          self.dom.emailInput.parentElement.parentElement.component.setError(err.message);
          self.dom.recoverySubmitBtn.disabled = false;
        });
    });

    // click on layer adding open class
    this.$component.addEventListener('click',(e) => {
      // adding class
      self.dom.myAccountLayerWrapper.classList.add(self.CSS.visible);
    });
    // mouseleave from div
    this.dom.myAccountLayerWrapper.addEventListener('mouseleave', e => {
      // for google autocompilation
      if(self.dom.formEmailInput === document.activeElement || self.dom.formPswInput === document.activeElement || document.querySelector(self.SELECTORS.emailInput) === document.activeElement) return false;
      // if is open and i click outside the div, close it
      if(self.dom.myAccountLayerWrapper.classList.contains(self.CSS.visible)) self.dom.myAccountLayerWrapper.classList.remove(self.CSS.visible);
    });
  }

  render() {
    this.dom = this.readDOM();
    this.bindEvents();
  }
}